import { FC, useContext, useEffect } from "react";
// import Emptymiddleware from '../middlewares/Emptymiddleware'
import TokenMiddlewareTable from "./Tokenmiddleware";

import { TableInputProps } from "../Table";

import store from "../../../store/store";
import { removeBreadcrumb } from "../../../components/Breadcrumbs/reducer/breadcrumbSlice";
import { GENERAL } from "../config/Transaction/ProductGeneralConf";
import { useSelector } from "react-redux";
import { fetchAllAdmins } from "../reducer/adminSlice";
// import { resetAddOfferRes } from "../reducer/adminSlice";
import { resetSignUp } from "../../../store/reducers/auth/authSlice";

const InitMiddlewareTable: FC<TableInputProps> = (props) => {
  const { categoryData } = useSelector((state: any) => state.rootReducer.brand);
  const { entityData, done } = useSelector((state: any) => state.DeletePopup);

  // console.log("done", done);

  useEffect(() => {
    store.dispatch(fetchAllAdmins());
  }, []);

  useEffect(() => {
    store.dispatch(removeBreadcrumb());
  }, []);

  useEffect(() => {
    if (done) {
      // console.log("done oooooooooooooooooo", done);
      store.dispatch(fetchAllAdmins());
    }
  }, [done]);

  useEffect(() => {
    store.dispatch(resetSignUp()); // Reset addOfferRes after navigation
  }, []);

  return <TokenMiddlewareTable {...props} />;
};

export default InitMiddlewareTable;
